/******************************************************
NOTE:
when using this component, you must wrap it in a SectionContainer on the page it's being used on with the following props:

            <SectionContainer
                bgColor={colors.midnight}
                textColor={colors.mist}
                topSpacing="4xl"
                bottomSpacing="4xl"
            >

                <HeroLandingPage
                    (props)
                />

            </SectionContainer>

******************************************************/
import React from "react";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden"; // to hide mobile image on tablet and desktop

import DefaultSearch from "core/SiteHeader/DefaultSearch";
import Heading from "core/Heading";

import { MaterialUIGridContainer } from "core/MaterialUI";
import colors from "core/colors";
import {
    HeroLandingPageContainer,
    HeadingAndInputContainer,
    SearchContainer,
    SearchIcon,
    MobileImg
} from "./styles";

const HeroLandingPage = ({
    heroImages,
    heading,
    headingColor,
    placeholder,
    bgSizeTablet,
    bgPositionTablet,
    bgSizeDesktop,
    bgPositionDesktop
}) => (
    <HeroLandingPageContainer
        desktopImg={heroImages.desktop}
        desktopMinHeight="592px"
        tabletImg={heroImages.tablet}
        tabletMinHeight="500px"
        bgSizeTablet={bgSizeTablet}
        bgPositionTablet={bgPositionTablet}
        bgSizeDesktop={bgSizeDesktop}
        bgPositionDesktop={bgPositionDesktop}
    >
        <HeadingAndInputContainer>
            <MaterialUIGridContainer
                mobileMaxPadding={3}
                tabletMaxPadding={3}
                desktopMinPadding={3}
                // passing in index 3 passes in the number "16" from the spacing array divided by 2 = 8px gutter as 16px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            >
                <Grid item sm={12} md={5} lg={6}>
                    <Heading
                        size="2xl"
                        bottomSpacing="3xl"
                        type="h1"
                        headingColor={headingColor}
                    >
                        {heading}
                    </Heading>
                    <SearchContainer>
                        <div id="hero-search-wrapper">
                            <SearchIcon fillColor={colors.fossil} size="md" />
                            <DefaultSearch placeholder={placeholder} />
                        </div>
                    </SearchContainer>

                    <Hidden mdUp>
                        <MobileImg src={heroImages.mobile} />
                    </Hidden>
                </Grid>
            </MaterialUIGridContainer>
        </HeadingAndInputContainer>
    </HeroLandingPageContainer>
);

HeroLandingPage.propTypes = {
    heroImages: PropTypes.object.isRequired,
    heading: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    headingColor: PropTypes.string,
    bgSizeTablet: PropTypes.string,
    bgPositionTablet: PropTypes.string,
    bgSizeDesktop: PropTypes.string,
    bgPositionDesktop: PropTypes.string
};

export default HeroLandingPage;
